
import StatCard from './StatCard';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Card2({ survivorsActivos, loading }) {


  if (survivorsActivos === null || survivorsActivos === undefined || survivorsActivos === 'empty') {
    if (!loading) {
      return (
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card shadow h-100 py-2">
            <div className="card-body">
              <td colSpan="3" className="text-center">No hay datos disponibles</td>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="col-xl-3 col-md-6 mb-4">
        <div className="card shadow h-100 py-2">
          <div className="card-body">
            <Skeleton height={20} width={120} className="mb-2" />
            <Skeleton height={30} width={80} />
          </div>
        </div>
      </div>
    );
  }

  return (

    <StatCard
      title="SURVIVORS EN LIVE"
      value={survivorsActivos}
      color="success"
      icon="fa-broadcast-tower"
    />
  );
}
